import ReactDOM from 'react-dom';
import './Modal.scss';
export default function Modal({ children, setIsPopupBooking, isPopupBooking = () => { } }) {
    return ReactDOM.createPortal(
        <div className={`modal ${isPopupBooking && 'visible'}`} onClick={() => setIsPopupBooking(false)}>
            <div onClick={(e) => e.stopPropagation()}>
                <div className={`modal__wrapper ${isPopupBooking && 'active'}`}>
                    {children || <div className="lds-ripple"><div></div><div></div></div>}
                </div>
            </div>
        </div>,
        document.querySelector('body'),
    );
}